import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { UploadService } from 'src/app/core/service/upload.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class MemberService {

  constructor(
    private requestService: RequestService,
    private uploadService: UploadService
  ) { }
  GetMemberInfo(CompanyID:string,UserID:string){
    var param = {
      "CompanyID": CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/Member/GetMemberInfo',param);
  }

  GetSelectOptionData(CompanyID:string){
    var param = {
      "CompanyID": CompanyID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/Member/GetSelectOptionDataForLine',param);
  }

  UpdateMemberInfo(model:any){
    return this.uploadService.makeFileRequest(environment.baseUrl + '/Member/UpdateMemberInfo',model,[]);
  }
  CreatePet(CompanyID:string,model:any,){
    var param = {
      "CompanyID": CompanyID,
      "model":model
    };
    return this.uploadService.makeFileRequest(environment.baseUrl + '/Member/CreatePet',param,[]);
  }
  /// <summary> 取得寵物病史選項資料 </summary>
  GetPetMedicalHistoryOptionData(CompanyID: string) {
    return this.requestService.Post(environment.baseUrl + '/Member/GetPetMedicalHistoryOptionData', { CompanyID: CompanyID });
  }
  /// <summary> 取得寵物貓砂選項資料 </summary>
  GetPetCatLitterOptionData(CompanyID: string) {
    return this.requestService.Post(environment.baseUrl + '/Member/GetPetCatLitterOptionData', { CompanyID: CompanyID });
  }
  /// <summary> 取得寵物疫苗選項資料 </summary>
  GetPetVaccineOptionData(CompanyID: string) {
    return this.requestService.Post(environment.baseUrl + '/Member/GetPetVaccineOptionData', { CompanyID: CompanyID });
  }
  /// <summary> 設定寵物病史資料 </summary>
  SetPetMedicalHistory(value: any,CompanyID: string) {
    return this.requestService.Post(environment.baseUrl + '/Member/SetPetMedicalHistory',  { CompanyID: CompanyID,model: value });
  }
  /// <summary> 設定寵物貓砂資料 </summary>
  SetPetCatLitter(value: any,CompanyID: string) {
    return this.requestService.Post(environment.baseUrl + '/Member/SetPetCatLitter',   { CompanyID: CompanyID,model: value });
  }
  /// <summary> 設定寵物疫苗資料 </summary>
  SetPetVaccine(value: any,CompanyID: string) {
    return this.requestService.Post(environment.baseUrl + '/Member/SetPetVaccine',   { CompanyID: CompanyID,model: value });
  }
}
